import { useQuery } from '@tanstack/react-query';
import { emailScheduleService } from '@/services/emailScheduleService';
import type { EmailSchedule } from '@/types/emailSchedule';
import { queryKeys } from '@/lib/queryKeys';
import { useAuth } from '@/hooks/useAuth';
import { API_CONFIG } from '@/config/api';

export const useEmailSchedules = () => {
  const { isAuthenticated } = useAuth();
  return useQuery<EmailSchedule[]>({
    queryKey: queryKeys.notifications.emailSchedules.list(),
    queryFn: () => emailScheduleService.list(),
    enabled: isAuthenticated,
    staleTime: API_CONFIG.CACHE_STALE_TIME_MS,
  });
};
